/**
 * Shared ECharts configuration for Pie and Donut charts.
 * Provides consistent styling and behavior for label overflow handling.
 */

/**
 * Get the base legend configuration for pie/donut charts.
 * Uses scrollable legend with truncation for many items.
 * @returns {Object} ECharts legend configuration
 */
export function getPieChartLegendConfig() {
  return {
    type: 'scroll',
    orient: 'vertical',
    left: 'left',
    top: 20,
    bottom: 20,
    textStyle: {
      fontSize: 11,
      overflow: 'truncate',
      width: 100,
    },
    pageButtonItemGap: 5,
    pageButtonGap: 5,
    pageIconSize: 12,
  };
}

/**
 * Get the base tooltip configuration for pie/donut charts.
 * @returns {Object} ECharts tooltip configuration
 */
export function getPieChartTooltipConfig() {
  return {
    trigger: 'item',
    confine: true,
    formatter: '{a} <br/>{b}: {c} ({d}%)',
  };
}

/**
 * Get the label configuration for pie/donut charts.
 * Includes overflow handling and auto-hide for overlapping labels.
 * @returns {Object} ECharts label configuration
 */
export function getPieChartLabelConfig() {
  return {
    show: true,
    formatter: '{b}: {d}%',
    fontSize: 11,
    overflow: 'truncate',
    width: 80,
  };
}

/**
 * Get the label line configuration for pie/donut charts.
 * @returns {Object} ECharts labelLine configuration
 */
export function getPieChartLabelLineConfig() {
  return {
    show: true,
    length: 10,
    length2: 10,
  };
}

/**
 * Get the label layout configuration for pie/donut charts.
 * @returns {Object} ECharts labelLayout configuration
 */
export function getPieChartLabelLayoutConfig() {
  return {
    hideOverlap: true,
  };
}

/**
 * Get the emphasis configuration for pie/donut charts.
 * @returns {Object} ECharts emphasis configuration
 */
export function getPieChartEmphasisConfig() {
  return {
    itemStyle: {
      shadowBlur: 10,
      shadowOffsetX: 0,
      shadowColor: 'rgba(0, 0, 0, 0.5)',
    },
  };
}
